<div class="product-bin bg-white">
  <div class="product-bin-header">
    <div class="d-flex align-items-center justify-content-between mb-2 gap-2">
      <p class="lead m-0 fw-bold">Product Bin</p>
      <!-- Added bold -->
      <div class="d-flex align-items-center justify-content-around gap-2 small">
        <!-- Added small text -->
        <div class="form-check form-switch" title="Show products currently on the planogram">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="showOnLayout"
            (change)="onShowOnLayoutChange($event)"
            id="showOnLayoutCheck"
          />
          <label class="form-check-label" for="showOnLayoutCheck">On</label>
        </div>
        <div class="form-check form-switch" title="Show products not yet on the planogram">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="showOffLayout"
            (change)="onShowOffLayoutChange($event)"
            id="showOffLayoutCheck"
          />
          <label class="form-check-label" for="showOffLayoutCheck">Off</label>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-2 gap-2">
      <input
        class="form-control form-control-sm"
        type="search"
        placeholder="Search..."
        (input)="onSearch($event)"
      />

      <!-- Group By Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          id="dropdownGroupFilter"
          ngbDropdownToggle
          title="Group By"
        >
          <i class="bi bi-collection"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownGroupFilter">
          <button ngbDropdownItem (click)="onGroupBySelected('')">None</button>
          <button ngbDropdownItem (click)="onGroupBySelected('Flow')">Flow</button>
          <button ngbDropdownItem (click)="onGroupBySelected('Brand')">Brand</button>
          <button ngbDropdownItem (click)="onGroupBySelected('Segment')">Segment</button>
          <button ngbDropdownItem (click)="onGroupBySelected('Family')">Family</button>
          <button ngbDropdownItem (click)="onGroupBySelected('Base')">Base</button>
        </div>
      </div>

      <!-- Filter Dropdown -->
      <div ngbDropdown [autoClose]="'outside'" class="d-inline-block">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary position-relative"
          id="dropdownFilter"
          ngbDropdownToggle
          title="Filter"
        >
          <i class="bi bi-funnel"></i>
          @if (getActiveFilterCount() > 0) {
            <span class="badge bg-primary rounded-pill ms-1">{{ getActiveFilterCount() }}</span>
          }
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownFilter" class="product-bin-filter-panel">
          <div class="filter-section">
            <div class="filter-section-header">Range Status</div>
            @for (option of rangeStatusOptions; track option) {
              <label class="filter-option">
                <input
                  type="checkbox"
                  [checked]="isFilterSelected('rangeStatus', option)"
                  (change)="toggleFilter('rangeStatus', option)"
                />
                <span>{{ option }}</span>
              </label>
            }
          </div>

          <div class="filter-section">
            <div class="filter-section-header">Refresh Plan</div>
            @for (option of refreshPlanOptions; track option) {
              <label class="filter-option">
                <input
                  type="checkbox"
                  [checked]="isFilterSelected('refreshPlan', option)"
                  (change)="toggleFilter('refreshPlan', option)"
                />
                <span>{{ option }}</span>
              </label>
            }
          </div>

          <div class="filter-section">
            <div class="filter-section-header">Lifecycle Status</div>
            @for (option of lifecycleOptions; track option) {
              <label class="filter-option">
                <input
                  type="checkbox"
                  [checked]="isFilterSelected('lifecycle', option)"
                  (change)="toggleFilter('lifecycle', option)"
                />
                <span>{{ option }}</span>
              </label>
            }
          </div>

          <div class="filter-section">
            <div class="filter-section-header">Brand</div>
            @for (option of productBinService.availableBrands$ | async; track option.name) {
              <label class="filter-option">
                <input
                  type="checkbox"
                  [checked]="isFilterSelected('brand', option.name)"
                  (change)="toggleFilter('brand', option.name)"
                />
                <span>{{ option.name }} ({{ option.count }})</span>
              </label>
            }
          </div>

          <div class="filter-section">
            <div class="filter-section-header">Manufacturer</div>
            @for (option of productBinService.availableManufacturers$ | async; track option.name) {
              <label class="filter-option">
                <input
                  type="checkbox"
                  [checked]="isFilterSelected('manufacturer', option.name)"
                  (change)="toggleFilter('manufacturer', option.name)"
                />
                <span>{{ option.name }} ({{ option.count }})</span>
              </label>
            }
          </div>

          <div class="filter-section">
            <div class="filter-section-header">Category</div>
            @for (option of productBinService.availableCategories$ | async; track option.name) {
              <label class="filter-option">
                <input
                  type="checkbox"
                  [checked]="isFilterSelected('category', option.name)"
                  (change)="toggleFilter('category', option.name)"
                />
                <span>{{ option.name }} ({{ option.count }})</span>
              </label>
            }
          </div>

          <div class="filter-section">
            <div class="filter-section-header">Segment</div>
            @for (option of productBinService.availableSegments$ | async; track option.name) {
              <label class="filter-option">
                <input
                  type="checkbox"
                  [checked]="isFilterSelected('segment', option.name)"
                  (change)="toggleFilter('segment', option.name)"
                />
                <span>{{ option.name }} ({{ option.count }})</span>
              </label>
            }
          </div>

          <div class="filter-section">
            <div class="filter-section-header">Family</div>
            @for (option of productBinService.availableFamilies$ | async; track option.name) {
              <label class="filter-option">
                <input
                  type="checkbox"
                  [checked]="isFilterSelected('family', option.name)"
                  (change)="toggleFilter('family', option.name)"
                />
                <span>{{ option.name }} ({{ option.count }})</span>
              </label>
            }
          </div>

          <div class="filter-section">
            <div class="filter-section-header">Base</div>
            @for (option of productBinService.availableBases$ | async; track option.name) {
              <label class="filter-option">
                <input
                  type="checkbox"
                  [checked]="isFilterSelected('base', option.name)"
                  (change)="toggleFilter('base', option.name)"
                />
                <span>{{ option.name }} ({{ option.count }})</span>
              </label>
            }
          </div>

          <div class="filter-footer">
            <button class="btn btn-sm btn-outline-danger w-100" (click)="clearAllFilters()">
              Clear All Filters
            </button>
          </div>
        </div>
      </div>

      <!-- New: Sort By Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          id="dropdownSort"
          ngbDropdownToggle
          title="Sort By"
        >
          <i class="bi bi-sort-alpha-down"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownSort">
          <button
            ngbDropdownItem
            (click)="onSortSelected('Name')"
            [class.active]="sortBy === 'Name'"
          >
            Name
          </button>
          <button
            ngbDropdownItem
            (click)="onSortSelected('Brand')"
            [class.active]="sortBy === 'Brand'"
          >
            Brand
          </button>
          <button
            ngbDropdownItem
            (click)="onSortSelected('Height')"
            [class.active]="sortBy === 'Height'"
          >
            Height (Desc)
          </button>
          <button
            ngbDropdownItem
            (click)="onSortSelected('Width')"
            [class.active]="sortBy === 'Width'"
          >
            Width (Desc)
          </button>
        </div>
      </div>
    </div>
  </div>

  <hr class="m-2" />

  <div [id]="productBinId" class="product-bin-content custom-scrollbar">
    @if (groupBy) {
    <div class="d-flex justify-content-between align-items-center ms-2 me-2 mb-2">
      <small class="text-muted"
        >Grouping by: <strong>{{ groupBy }}</strong></small
      >
      <!-- Add Expand/Collapse All buttons here if needed -->
    </div>

    <!-- Group visibility filter list -->
    <div class="group-filter-list ms-2 mb-2">
      @for (groupedProduct of groupedproducts$ | async; track groupedProduct.group) {
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="isGroupVisible(groupedProduct.group)"
          (change)="toggleGroupVisibility(groupedProduct.group)"
          [id]="'groupFilter-' + groupedProduct.group"
        />
        <label
          class="form-check-label"
          [for]="'groupFilter-' + groupedProduct.group"
        >
          {{ groupedProduct.group }}
        </label>
      </div>
      }
    </div>

    <!-- Render grouped products -->
    @for (groupedProduct of groupedproducts$ | async; track groupedProduct.group) {
      @if (isGroupVisible(groupedProduct.group)) {
      <div class="grouped-products">
        <div
          class="group-header sticky-top bg-light"
          (click)="toggleGroup(groupedProduct.group)"
        >
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-center flex-grow-1">
              <i
                [ngClass]="
                  isGroupExpanded(groupedProduct.group)
                    ? 'bi bi-chevron-down'
                    : 'bi bi-chevron-right'
                "
                class="me-2 text-primary"
              ></i>
              <span class="fw-bold text-truncate">{{
                groupedProduct.group
              }}</span>
            </div>
            <span class="badge bg-secondary ms-auto rounded-pill">{{
              groupedProduct.products.length
            }}</span>
          </div>
        </div>

        @if (isGroupExpanded(groupedProduct.group)) {
        @for (product of groupedProduct.products; track product.productId) {
        <app-product-bin-product
          [productRef]="product"
        ></app-product-bin-product>
        } }
      </div>
      } }
    }

    <!-- No grouping fallback -->
    @if (!groupBy) {
    @for (product of products$ | async; track product.productId) {
    <app-product-bin-product [productRef]="product"></app-product-bin-product>
    } }
  </div>
</div>

